import React, { useContext, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { analyticsManager } from "../../../reducers/analytics.slice";
import { getUsers } from "../../../utils/getUser";
import { AuthContext } from "../../../context/authContext";
import PageHeader from "../../../components/shared/PageHeader";
import StatCard from "../../../components/shared/StatCard";
import useMediaQuery from "../../../components/shared/useMediaQuery";

const STAT_ACCENTS = ["#00ADB5", "#e8b84b", "#4caf50", "#af58f2", "#22d3ee", "#f27059"];

const keyToRouteMap = {
  pending_manager_approval: "/dashboard/pending-rsc-quotes",
  pending_member_approval: "/dashboard/pending-rsc-quotes",
  labels_pending: "/dashboard/shipment",
  shipment_pending: "/dashboard/shipment",
  payment_pending: "/dashboard/payouts",
  payment_ready: "/dashboard/payouts",
  early_payments: "/dashboard/payouts",
};

const AdminDashboard = () => {
  const [analyticsData, setAnalyticsData] = useState([]);
  const [loading, setLoading] = useState(false);
  const user = getUsers();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userDetails, showToast } = useContext(AuthContext);
  const isMobile = useMediaQuery("(max-width: 640px)");

  useEffect(() => {
    const payload = {
      userId: user?.id || user?.id,
      access_token: userDetails?.access_token || user?.access_token,
    };

    setLoading(true);
    dispatch(analyticsManager(payload)).then((res) => {
      if (res?.error && Object.keys(res?.error)?.length > 0) {
        setLoading(false);
        showToast(res?.error?.message, "error");
        return;
      }
      setLoading(false);
      if (res?.payload) {
        const dataArray = Object.keys(res.payload).map((key) => ({
          key,
          title: key.replace(/_/g, " ").replace(/\b\w/g, (char) => char.toUpperCase()),
          value: res.payload[key],
          route: keyToRouteMap[key] || "/",
        }));
        setAnalyticsData(dataArray);
      } else {
        console.error("No payload in response:", res);
      }
    });
  }, [dispatch, user?.id]);

  return (
    <div style={{ maxWidth: 1200, margin: "0 auto", width: "100%" }}>
      <div style={{ marginBottom: isMobile ? 20 : 26 }}>
        <PageHeader title={`Welcome ${user?.first_name || ""}`} subtitle="Monitor management activity and operational queues." />
      </div>

      {loading && analyticsData.length === 0 ? (
        <div style={{ padding: "40px 0", textAlign: "center", color: "#c3c8cc", fontSize: 13.5 }}>
          Loading dashboard...
        </div>
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "repeat(auto-fit, minmax(145px, 1fr))" : "repeat(auto-fit, minmax(190px, 1fr))",
            gap: isMobile ? 12 : 16,
          }}
        >
          {analyticsData.map((data, index) => (
            <StatCard
              key={data.key}
              label={data.title}
              value={data.value}
              accent={STAT_ACCENTS[index % STAT_ACCENTS.length]}
              actionLabel={data.route !== "/" ? "view →" : undefined}
              onClick={data.route !== "/" ? () => navigate(data.route) : undefined}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminDashboard;
